document.addEventListener('DOMContentLoaded', () => {

    const storeHeader = document.querySelector('store-header[transparent]');
    // Unlike storeHeader above, not scoped to [transparent] — every header (opaque included)
    // needs pinning while a drawer's scroll lock is active, not just transparent ones.
    const headerElement = document.querySelector('store-header');
    const headerWrapperEl = headerElement && headerElement.closest('.shopify-section');

    /* Created once and left in the DOM (starts at zero height) rather than inserted/removed on
    every open and close, since churning DOM nodes on every interaction is expensive. Placed
    explicitly before the header rather than relying on nextElementSibling, which isn't
    necessarily the next thing visually (e.g. a cookie-banner section rendered after it in
    markup but positioned elsewhere on screen). */
    const headerFlowSpacer = headerWrapperEl && document.createElement('div');
    if (headerFlowSpacer) {
        headerFlowSpacer.className = 'js-scroll-lock-flow-spacer';
        headerFlowSpacer.style.height = '0px';
        headerFlowSpacer.setAttribute('aria-hidden', 'true');
        headerWrapperEl.insertAdjacentElement('beforebegin', headerFlowSpacer);
    }

    /* Elements that use position: sticky (or fixed) and can end up somewhere else entirely while
    scroll is locked for an open drawer — see the pinStickyElements/unpinStickyElements comment
    below for why. Add a selector here for any other sticky element that turns out to need it. */
    const SCROLL_LOCK_STICKY_SELECTORS = ['.alt-product__info.product__info'];

    /* Each drawer renders its own search bar, so these are collected as they're wired up and share
    the single click-outside listener registered below — one listener for the page rather than one
    per bar. The abort controller and debounce timer stay in each bar's own closure. */
    const searchBars = [];

    /* Inline predictive search inside the nav drawer */
    document.querySelectorAll('.header--drawer-search-bar').forEach((bar) => {
        const input = bar.querySelector('[name="q"]');
        const clearInputBtn = bar.querySelector('.predictive-search__clear');
        const resultsEl = bar.querySelector('.drawer-search-results');
        if (!input || !resultsEl) return;

        let abortController = null;
        let debounceTimer = null;

        function closeResults() {
            resultsEl.hidden = true;
            resultsEl.innerHTML = '';
        }

        async function onInput() {
            const term = input.value.trim();
            if (abortController) abortController.abort();
            if (!term) { closeResults(); return; }

            abortController = new AbortController();
            try {
                const url = `${window.themeVariables.routes.predictiveSearchUrl}?q=${encodeURIComponent(term)}&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search`;
                const response = await fetch(url, { signal: abortController.signal });
                const wrapper = document.createElement('div');
                wrapper.innerHTML = await response.text();
                const html = wrapper.firstElementChild && wrapper.firstElementChild.innerHTML;
                if (html) {
                    resultsEl.innerHTML = html;
                    resultsEl.hidden = false;
                }
            } catch (e) {
                if (e.name !== 'AbortError') throw e;
            }
        }

        function syncClearButton() {
            if (clearInputBtn) {
                clearInputBtn.hidden = input.value.trim().length === 0;
            }
        }

        syncClearButton();

        input.addEventListener('input', () => {
            syncClearButton();
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(onInput, 200);
        });

        function clearSearchBarInput() {
            /* A pending debounce and an in-flight request both have to go, not just the input's
            value: a request that resolves after the clear would otherwise write its results back
            into the panel the user has already dismissed. */
            clearTimeout(debounceTimer);
            if (abortController) abortController.abort();
            closeResults();
            input.value = "";
            syncClearButton();
        }

        if (clearInputBtn) {
            clearInputBtn.addEventListener('click', () => {
                clearSearchBarInput();
            });
        }

        searchBars.push({ bar, clear: clearSearchBarInput });
    });

    /* Clearing a search bar when a click lands outside it. One listener walks the composed path once
    and checks every bar against it, rather than each bar registering its own document-wide listener
    and each recomputing the same path on every click anywhere on the page. */
    if (searchBars.length) {
        document.addEventListener('click', (event) => {
            const path = event.composedPath();
            searchBars.forEach(({ bar, clear }) => {
                if (!path.includes(bar)) clear();
            });
        });
    }

    const topLevelNavItems = document.querySelectorAll('[id^="toplevel-nav-item--"]');
    const firstLevelNavItems = document.querySelectorAll('[id^="tier-one-item--"]');
    const tierTwoItems = document.querySelectorAll('[id^="tier-two-item--"]')
    const tierOneDrawers = document.querySelectorAll('[id^="tier-one-drawer--"]');
    const tierTwoDrawer = document.querySelectorAll('[id^="tier-two-drawer--"]');

    // Cross-fades between two already-open sibling drawers instead of a close-then-open. Used for tier one.
    function createDrawerSwitcher() {
        let pendingFinish = null;
        // Applies the deferred is-switching reset scheduled by the last finish(); see below.
        let pendingSwitchingReset = null;

        // Cross-fades to targetDrawer from whichever drawer in drawerGroup is currently active; returns false (does nothing) if there's no real switch to make, so the caller can fall back to a plain toggle.
        function switchTo(drawerGroup, targetDrawer) {
            if (pendingFinish) {
                pendingFinish();
                pendingFinish = null;
            }
            /* Applied now rather than mid-switch, where it would strip is-switching from the drawer sliding in — and applied rather than just cancelled, so an uninvolved drawer isn't left stuck with it. */
            if (pendingSwitchingReset) {
                pendingSwitchingReset();
            }
            // Read the active drawer only after flushing above — flushing can itself change which drawer is active, so reading earlier would risk switching from a drawer that's no longer the current one.
            const previouslyActiveDrawer = Array.from(drawerGroup).find((drawer) => drawer.classList.contains('is-active')) || null;
            if (!previouslyActiveDrawer || !targetDrawer || previouslyActiveDrawer === targetDrawer) return false;

            previouslyActiveDrawer.classList.add('is-switching');
            targetDrawer.classList.add('is-switching');
            // .drawer--fade-content is the part of the drawer that fades; falls back to the drawer itself if a template hasn't added the wrapper yet.
            const targetFadeContent = targetDrawer.querySelector('.drawer--fade-content') || targetDrawer;

            targetDrawer.style.zIndex = '150';
            targetDrawer.classList.add('is-active');
            // is-switching zeroes the transform transition, so adding is-active here snaps the drawer into position instantly rather than sliding.
            targetFadeContent.style.opacity = '0';

            // Forces the opacity:0 above to commit before it's cleared below, otherwise the browser combines both writes and skips the fade transition.
            void targetFadeContent.offsetHeight;
            targetFadeContent.style.opacity = '';

            let settled = false;
            let timeoutId;
            const finish = () => {
                if (settled) return;
                settled = true;
                // is-switching is still on while is-active is removed, so the outgoing drawer snaps away instantly instead of sliding over the new one.
                previouslyActiveDrawer.classList.remove('is-active');
                targetDrawer.classList.remove('is-switching');
                targetDrawer.style.zIndex = '';
                targetFadeContent.removeEventListener('transitionend', onTransitionEnd);
                clearTimeout(timeoutId);
                if (pendingFinish === finish) pendingFinish = null;
                // Deferred so the instant snap above paints first, and tracked so switchTo can apply it early.
                let switchingResetId;
                const resetSwitching = () => {
                    clearTimeout(switchingResetId);
                    previouslyActiveDrawer.classList.remove('is-switching');
                    if (pendingSwitchingReset === resetSwitching) pendingSwitchingReset = null;
                };
                switchingResetId = setTimeout(resetSwitching, 50);
                pendingSwitchingReset = resetSwitching;
            };
            function onTransitionEnd(event) {
                if (event.target === targetFadeContent && event.propertyName === 'opacity') finish();
            }
            targetFadeContent.addEventListener('transitionend', onTransitionEnd);
            // Safety net in case transitionend doesn't fire.
            timeoutId = setTimeout(finish, 300);
            pendingFinish = finish;
            return true;
        }

        return { switchTo };
    }

    /* Swaps one open drawer for a sibling without sliding: transitions are killed for one frame so both
     panels snap (the incoming lands exactly where the outgoing was), making the panel look like it stays
     put while the incoming drawer's staggered text reveal replays. The reflow commits the snap before
     transitions are restored, so a later open/close still slides. */
    function swapInPlace(outgoing, incoming) {
        outgoing.style.transition = 'none';
        incoming.style.transition = 'none';
        outgoing.classList.remove('is-active');
        incoming.classList.add('is-active');
        void incoming.offsetWidth;
        outgoing.style.transition = '';
        incoming.style.transition = '';
    }

    /* clicking a tier-one--item should open its corresponding tier-two-drawer. The item and the drawer
    will contain the same child_link.title text in their ids
    when the ids match, show all items in the drawer with the matching ids, and hide everything else
    */

    function toggleTieredMenuDisplays(navItems, nextTierNavItems, topLevelIdString, nextTierItemIdString, activeButtonSelector, switcher) {
        function findMatchingDrawer(navItem) {
            const navId = navItem.id.replace(topLevelIdString, '');
            return Array.from(nextTierNavItems).find((nextTierNavItem) => {
                return nextTierNavItem.id.replace(nextTierItemIdString, '') === navId;
            }) || null;
        }

        function activate(navItem) {
            document.dispatchEvent(new CustomEvent('nav-drawer:item-click', {
                detail: {
                    tier: topLevelIdString === 'toplevel-nav-item--' ? 'top-level' : 'second-tier',
                    // Top-level items carry their label in data-drawer-content; second-tier items use aria-label instead.
                    label: navItem.dataset.drawerContent || navItem.getAttribute('aria-label') || navItem.id
                }
            }));

            const targetDrawer = findMatchingDrawer(navItem);

            // Tier-one flow closes any open tier-two (subcategory) drawer when switching top-level category.
            // Skip in the tier-two flow, where switching between subcategories is handled in place below.
            if (nextTierNavItems !== tierTwoDrawer) {
                tierTwoDrawer.forEach((drawer) => {
                    drawer.classList.remove('is-active');
                })
            }

            let handled = false;
            if (switcher) {
                // Tier one: cross-fade between drawers.
                handled = switcher.switchTo(nextTierNavItems, targetDrawer);
            } else if (targetDrawer) {
                // Tier two: if another subcategory drawer is already open, swap to this one in place (no slide) so the panel stays put and only the staggered text reveal replays.
                const openSibling = Array.from(nextTierNavItems).find((drawer) => drawer.classList.contains('is-active'));
                if (openSibling && openSibling !== targetDrawer) {
                    swapInPlace(openSibling, targetDrawer);
                    handled = true;
                }
            }

            // Fresh open (or a leaf item with no drawer): plain toggle. This also replays the staggered reveal, and slides the panel in since it wasn't already on screen.
            if (!handled) {
                nextTierNavItems.forEach((nextTierNavItem) => {
                    nextTierNavItem.classList.toggle('is-active', nextTierNavItem === targetDrawer);
                });
            }

            const openedDrawer = targetDrawer && targetDrawer.classList.contains('is-active') ? targetDrawer : null;

            // Desktop's top-level nav button lives at a different depth than the
            // mobile drawer strip button, so its own selected state is toggled
            // here rather than reusing the mobile strip's click handler.
            if (activeButtonSelector) {
                navItems.forEach((item) => {
                    const btn = item.querySelector(activeButtonSelector);
                    if (btn) btn.classList.toggle('is-active', item === navItem);
                });
            }

            /* Move focus into the newly opened submenu, so that tabbing from the
            trigger lands on the submenu's first item 
            
            Preventing page scroll when the drawers are open
            */
            if (openedDrawer) {
                const firstItemLink = openedDrawer.querySelector('.header--drawer-items a');
                if (firstItemLink) firstItemLink.focus({ preventScroll: true });
            }
        }

        navItems.forEach((navItem) => {
            // Tier-one items are real <a href> links (leaf items with no children have
            // nowhere else to go and should navigate normally). Only items with a
            // matching next-tier drawer should have their default link behavior
            // suppressed in favor of opening the submenu.
            const hasSubmenu = !!findMatchingDrawer(navItem);

            navItem.addEventListener('click', (event) => {
                if (hasSubmenu) event.preventDefault();
                activate(navItem);
            });

            // Native buttons already fire a click event on Enter/Space, so only
            // items that aren't natively interactive (e.g. the tier-one <li> items)
            // need an explicit keydown handler to be keyboard-activatable.
            if (hasSubmenu && navItem.tagName !== 'BUTTON') {
                navItem.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        activate(navItem);
                    }
                });
            }
        })
    }

    // Shared per drawer-tier so every path that can switch between tier-one drawers (desktop top nav below, mobile strip buttons further down) cross-fades through the same switcher and can't race each other.
    const tierOneSwitcher = createDrawerSwitcher();
    toggleTieredMenuDisplays(topLevelNavItems, tierOneDrawers, 'toplevel-nav-item--', 'tier-one-drawer--', '.toplevel-item--btn-wrapper button', tierOneSwitcher);
    // No switcher for tier two: it plain-toggles, which replays the staggered text reveal on each subcategory change.
    toggleTieredMenuDisplays(firstLevelNavItems, tierTwoDrawer, 'tier-one-item--', 'tier-two-drawer--', null, null);

    /* Background overlay: darken the page whenever any drawer panel is open so the
    drawers stand out. Clicking the overlay closes any open drawers. */
    const wrapper = document.querySelector('.drawer--header-wrapper');
    const overlay = wrapper && wrapper.querySelector('[data-drawer-overlay]');

    if (overlay) {
        const drawers = wrapper.querySelectorAll('.header--drawer');
        // Mobile-only close icon in the drawer header. Hidden until a drawer opens.
        const toplevelStripBtns = wrapper.querySelectorAll('.drawer-toplevel-strip__btn');
        const desktoTpoplevelStripBtns = wrapper.querySelectorAll('.toplevel-item--btn-wrapper button');

        /* removing the tabindex for drawers that are off-screen. Once the drawers come back
        on screen, the tabindex is added back */
        const drawerFocusableState = new WeakMap();

        function syncDrawerFocusability() {
            drawers.forEach((drawer) => {
                const isOpen = drawer.classList.contains('is-active');
                /* Walking a drawer's focusable nodes is the costly part of a sync, and only one or
                two drawers change per interaction, so drawers whose open state hasn't moved since
                the last pass are skipped rather than rewritten with the values they already hold. */
                if (drawerFocusableState.get(drawer) === isOpen) return;
                drawerFocusableState.set(drawer, isOpen);
                /* The drawer element itself is included alongside its children: a drawer is a
                scroll container, and Chrome puts scroll containers with no tabbable children in
                the tab order in their own right, so a closed drawer would otherwise be a tab stop
                on a panel that's off-screen. */
                [drawer, ...drawer.querySelectorAll('a[href], button, input, select, textarea')].forEach((el) => {
                    if (isOpen) {
                        el.removeAttribute('tabindex');
                    } else {
                        el.setAttribute('tabindex', '-1');
                    }
                });
            });
        }

        /* Keeps the disclosure buttons' aria-expanded truthful. Driven off aria-controls in the
        markup rather than a second copy of the id-pairing rules, and scoped to triggers that
        control a drawer so the footer's country/locale buttons — OpenableElements that maintain
        their own aria-expanded — are left alone. */
        function syncDrawerAriaExpanded() {
            wrapper.querySelectorAll('[aria-controls][aria-expanded]').forEach((trigger) => {
                const controlled = document.getElementById(trigger.getAttribute('aria-controls'));
                if (controlled && controlled.classList.contains('header--drawer')) {
                    trigger.setAttribute('aria-expanded', controlled.classList.contains('is-active'));
                }
            });
        }

        // Scroll offset held across a lock, so closing a drawer can put the page back where it was.
        let scrollYBeforeLock = 0;
        let scrollLocked = false;

        /* Locking scroll (below) turns <body> into position: fixed with a negative top offset, which
        freezes the page visually in place but breaks every position: sticky element on the page —
        each one recalculates against the now-collapsed scroll container and jumps by the locked
        scroll offset instead of staying where it visually was (the header itself needed this fix
        first; see the git history on the body.overflow-hidden rule in header.liquid). Rather than
        pin each such element with its own hand-tuned offset, snapshot exactly where it's rendered
        right before locking and hold it there with an inline position: fixed at that same spot. */
        function pinElement(el, { isHeader }) {
            const rect = el.getBoundingClientRect();
            if (isHeader) {
                // The drawer pads its content down by --header-height to clear the header, which
                // undershoots when the header isn't flush with the viewport top (e.g. an
                // unscrolled, non-sticky announcement bar pushing it down) — publish its real
                // bottom edge so the drawer can pad against that instead.
                document.documentElement.style.setProperty('--drawer-header-offset', `${rect.bottom}px`);

                // Pinning removes the header from flow, which would otherwise collapse its space
                // and drag everything below it upward. headerFlowSpacer holds that space open,
                // sized to the header's NET contribution (accounting for its own margin-bottom,
                // which is negative on transparent-header pages) rather than its raw height.
                if (headerFlowSpacer) {
                    const marginBottom = parseFloat(getComputedStyle(el).marginBottom) || 0;
                    headerFlowSpacer.style.height = `${Math.max(0, rect.height + marginBottom)}px`;
                }
            }
            el.classList.add('js-scroll-lock-pinned');
            el.style.setProperty('position', 'fixed', 'important');
            el.style.setProperty('top', `${rect.top}px`, 'important');
            el.style.setProperty('left', `${rect.left}px`, 'important');
            el.style.setProperty('width', `${rect.width}px`, 'important');
        }

        function pinStickyElements() {
            if (headerWrapperEl) pinElement(headerWrapperEl, { isHeader: true });

            // Only pin these where they're actually position: sticky (the PDP's alt-layout info
            // column is sticky at >=1000px but a plain block below that) — pinning a plain block
            // rips its height out of flow with nothing to reserve the space, which is what caused
            // content to jump on tablet/mobile.
            SCROLL_LOCK_STICKY_SELECTORS.forEach((selector) => {
                document.querySelectorAll(selector).forEach((el) => {
                    if (getComputedStyle(el).position === 'sticky') pinElement(el, {});
                });
            });
        }

        function unpinStickyElements() {
            document.querySelectorAll('.js-scroll-lock-pinned').forEach((el) => {
                el.classList.remove('js-scroll-lock-pinned');
                el.style.removeProperty('position');
                el.style.removeProperty('top');
                el.style.removeProperty('left');
                el.style.removeProperty('width');
            });
            if (headerFlowSpacer) headerFlowSpacer.style.height = '0px';
            document.documentElement.style.removeProperty('--drawer-header-offset');
        }

        // Tracked across syncOverlay() calls so FullStory nav-drawer events only fire on an actual open/close transition.
        let wasOpen = false;
        // Set by each close site right before it removes is-active, so the close event can report how the drawer closed.
        let lastCloseMethod = 'unknown';

         function removeActiveState(elementsList, removeConditionCase) {
            elementsList.forEach(el => {
                if (el.classList.contains('is-active') && removeConditionCase == false) {
                    el.classList.remove('is-active');
                }
            })
        }

        function syncOverlay() {
            const anyOpen = Array.from(drawers).some((drawer) => drawer.classList.contains('is-active'));

            // FullStory nav-drawer events: every open/close path funnels through this MutationObserver-driven
            // sync, so this is the one place that needs to watch for the transition.
            if (anyOpen && !wasOpen) {
                document.dispatchEvent(new CustomEvent('nav-drawer:open'));
            } else if (!anyOpen && wasOpen) {
                document.dispatchEvent(new CustomEvent('nav-drawer:close', { detail: { method: lastCloseMethod } }));
                lastCloseMethod = 'unknown';
            }
            wasOpen = anyOpen;

            overlay.classList.toggle('is-active', anyOpen);
            syncDrawerFocusability();
            syncDrawerAriaExpanded();

            //making the header transparent when any drawers are opened
            if (storeHeader) {
                if (anyOpen) {
                    storeHeader.setAttribute('header-drawer', 'open');
                    storeHeader.classList.add('header--transparent');
                } else {
                    storeHeader.removeAttribute('header-drawer');
                    /* When drawers are closed, transparency state of header is
                    controlled by the store headers transparent header logic */
                    if (typeof storeHeader._checkTransparentHeader === 'function') {
                        storeHeader._checkTransparentHeader();
                    }
                }
            }
            
            /*
            Capturing scroll offset when drawer opens, then adding that offset to the top of the drawer
            so that the drawer maintains its visual position.

            On drawer close, the scroll is set to the position it was before opening the drawer
            */
            if (anyOpen !== scrollLocked) {
                if (anyOpen) {
                    // Snapshot sticky elements' real on-screen position before anything about
                    // body's layout changes underneath them.
                    pinStickyElements();
                    scrollYBeforeLock = window.scrollY;
                    document.body.style.top = `-${scrollYBeforeLock}px`;
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                    document.body.style.top = '';
                    window.scrollTo({ top: scrollYBeforeLock, left: 0, behavior: 'instant' });
                    unpinStickyElements();
                }
                scrollLocked = anyOpen;
            }

            //removing is-active state for mobile and desktop top level nav items on drawer close
            removeActiveState(toplevelStripBtns, anyOpen);
            removeActiveState(desktoTpoplevelStripBtns, anyOpen);
        }

        /* Every open and close — here, the tier switching in toggleTieredMenuDisplays, and the
        cross-fade in createDrawerSwitcher — happens by toggling .is-active on a drawer, so this is
        the one place that reacts to it. Handlers deliberately don't also call syncOverlay()
        themselves: that ran the whole sync twice per interaction, once eagerly and once off the
        resulting class change. The observer batches a burst of changes into a single callback, so
        switching drawers still costs one sync rather than one per drawer touched. */
        const observer = new MutationObserver(syncOverlay);
        drawers.forEach((drawer) => {
            observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        });

        // Clicking the overlay closes all open drawers
        overlay.addEventListener('click', () => {
            lastCloseMethod = 'overlay';
            drawers.forEach((drawer) => drawer.classList.remove('is-active'));
        });

        /* Close buttons for the top level nav item links in the mobile drawers (one per tier-one drawer) */
        wrapper.querySelectorAll('.drawer-toplevel-strip__close').forEach((btn) => {
            btn.addEventListener('click', () => {
                lastCloseMethod = 'close_button';
                drawers.forEach((drawer) => drawer.classList.remove('is-active'));
            });
        });

        /* Back button inside a tier-two (grandchild) drawer: closes just that drawer so the
        tier-one drawer underneath — the one whose item was clicked to open it — is revealed,
        ee*/
        wrapper.querySelectorAll('.drawer--title-with-icon').forEach((backBtn) => {
            backBtn.addEventListener('click', () => {
                const drawer = backBtn.closest('.header--drawer');
                if (!drawer) return;
                lastCloseMethod = 'back_button';
                drawer.classList.remove('is-active');
            });
        });

        /* top level nav buttons — switch to the matching tier-one drawer
        Also toggling an is-active state on the drawer strip items when selected, e.g on mens, womens footwear
        */
        toplevelStripBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                const targetId = btn.dataset.target;
                const targetDrawer = Array.from(tierOneDrawers).find((drawer) => drawer.id === targetId) || null;
                const switched = tierOneSwitcher.switchTo(tierOneDrawers, targetDrawer);

                if (!switched) {
                    tierOneDrawers.forEach((drawer) => {
                        drawer.classList.toggle('is-active', drawer.id === targetId);
                    });
                }
                toplevelStripBtns.forEach((stripBtn) => {
                    stripBtn.classList.toggle('is-active', stripBtn.dataset.target === targetId);
                });
                tierTwoDrawer.forEach((drawer) => drawer.classList.remove('is-active'));
            });
        });

        /* Mobile hamburger: opens the first tier-one drawer.
           Closing is handled by the strip close button and the overlay. */
        const hamburger = document.querySelector('button[is="toggle-button"][aria-controls="mobile-alt-drawer-navigation"]');
        const firstWrapper = document.getElementById('mobile-alt-drawer-navigation');
        const firstTierDrawer = firstWrapper && firstWrapper.querySelector('.tier-one--items.header--drawer');

        if (hamburger && firstTierDrawer) {
            hamburger.addEventListener('click', () => {
                firstTierDrawer.classList.add('is-active');
                // Bolds the matching strip button, same as switching to it does, so it doesn't look unselected right after opening.
                toplevelStripBtns.forEach((stripBtn) => {
                    stripBtn.classList.toggle('is-active', stripBtn.dataset.target === firstTierDrawer.id);
                });
            });
        }

        /* Keyboard handling that the old <mobile-navigation> element inherited from OpenableElement
        and these plain-markup drawers don't get: Escape closes, and Tab stays inside the nav rather
        than walking into the page content sitting behind the overlay. Only the two ends of the nav
        are intercepted for Tab — everything in between still tabs in natural document order, so
        moving from one top-level item's drawer on to the next top-level item is unaffected. */
        document.addEventListener('keydown', (event) => {
            if (event.key !== 'Tab' && event.key !== 'Escape') return;
            if (!Array.from(drawers).some((drawer) => drawer.classList.contains('is-active'))) return;
            /* The country/locale popovers in the drawer footer are OpenableElements with their own
            focus trap and Escape handling, so an open one closes itself — leave its keys alone
            instead of tearing down the nav underneath it. */
            if (event.target.closest('popover-content[open]')) return;

            if (event.key === 'Escape') {
                /* Focus is usually on a drawer link that's about to move off-screen, so it goes back
                to whatever opened the drawer. The strip and the header's top-level items swap over by
                breakpoint, so take whichever is actually on screen; .is-active has to be read before
                the drawers close, because the sync that follows strips it. */
                const trigger = [wrapper.querySelector('.toplevel-item--btn-wrapper button.is-active'), hamburger]
                    .find((el) => el && el.checkVisibility({ checkVisibilityCSS: true }));
                lastCloseMethod = 'escape';
                drawers.forEach((drawer) => drawer.classList.remove('is-active'));
                if (trigger) trigger.focus({ preventScroll: true });
                return;
            }

            /* syncDrawerFocusability() has already given the closed drawers tabindex="-1", leaving
            the visibility check to rule out whatever is off-breakpoint (the desktop top-level
            items, the mobile strip and footer) and the collapsed country/locale popovers — those
            are visibility:hidden rather than display:none, so they still occupy layout boxes and
            would otherwise make an unfocusable country button look like the end of the nav. */
            const tabbable = Array.from(wrapper.querySelectorAll('a[href], button, input, select, textarea'))
                .filter((el) => !el.disabled && el.getAttribute('tabindex') !== '-1' && el.checkVisibility({ checkVisibilityCSS: true }));
            if (!tabbable.length) return;

            const first = tabbable[0];
            const last = tabbable[tabbable.length - 1];

            if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus({ preventScroll: true });
            } else if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus({ preventScroll: true });
            }
        });

        syncOverlay();
    }

})